import { IncidentQueryResult } from '@/graphql/generated/hooks'

export interface MapCoordinatesI {
  latitude: number
  longitude: number
}

/**
 * Resolves the point the Map Panel should center on.
 *
 * Market Facility Incidents carry their own coordinates — the reporter enters
 * geo coords or an address at incident time, and the facility itself has no
 * latitude/longitude on file. Every other incident falls back to the
 * facility's current coordinates. Incident-level coords win when both exist:
 * they describe where the incident happened, the facility only where it is
 * registered. Returns null when neither source has a usable point, which is
 * the signal to hide the Map Panel trigger entirely. ENG-33674
 */
export const getIncidentMapCoordinates = (
  incident: IncidentQueryResult['data']['incident']
): MapCoordinatesI | null => {
  // Each source is taken as a whole pair — a half-populated incident point
  // must not borrow the facility's other axis and plot a point that exists
  // nowhere.
  if (incident?.latitude != null && incident?.longitude != null) {
    return { latitude: incident.latitude, longitude: incident.longitude }
  }

  const { latitude, longitude } = incident?.facility ?? {}
  if (latitude == null || longitude == null) return null

  return { latitude, longitude }
}
